import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { StoreState } from '../../../../store/reducer-main';
import { Button as NUIButton } from '@nextui-org/react';
import { CareGiver, CaregiverAssignedFamilyData, CareGiverCovergaeAvailability, CareGiverFormData, CaregiverNationality, CareGiverNightTime, CareGiverOtherPeoplePresence, CareGiverPeronality, CaregiverPersonalityData, CareGiverSmokes, CareGiverWeekendAvailability, CaregiverWithAssignedFamilyData, CareGiverYearsOfExperience } from '../../../../types/caregivers';
import { useNavigate } from 'react-router';
import { createUserCareGiver, getSingleUserCareGiver, getSuggestedCareGiverMaxNumberOfPagses, getSuggestedCaregivers, getTsAgeRange, initCaregiverSearchResults, initSuggestedCaregiversTable, loadSuggestedCaregiverNextTablePage, loadSuggestedCaregiverPrevTablePage, searchCaregiverByName, searchCaregiverByNameSurname, updateUserCaregiver } from '../../../../service/caregiovers';
import { loadInterviewCareGiver, updateDistanceFromFamily } from '../../../../store/interview/slice';
import { Autocomplete, AutocompleteItem, DateInput, DateValue, Input, Select, Selection, SelectItem, Switch, Table, TableBody, TableCell, TableColumn, TableHeader, TableRow, Textarea } from '@nextui-org/react';
import { brkRef, calendarDate2Timestamp, formatDate, getNumberOfTraitsMetadata, getPositiviePersonalitiesMetadata, getStringKeywords, ts2Age } from '../../../../helpers/utils';
import { CalendarDate, RateSelectorValue, TablePaginationConfig, Trait, TraitData } from '../../../../types/common';
import Typography from '../../common/Typography';
import Button from '../../common/Button';
import { CARE_GIVER_PERSONALITIES_SELECTOR_DATA, /* CARE_GIVER_YEARS_OF_EXPERIENCE,  */CAREGIVER_COVERAGE_AVAILABILITY, CAREGIVER_NATIONALITIES, CAREGIVER_NATIONALITIES_SELECTOR_DATA, CAREGIVER_OTHER_PEOPLE_PRESENCE, CAREGIVER_SMOKES, CAREGIVER_WEEKEND_AVAILABILIY, CAREGIVERS_NIGHT_TIME } from '../../../../constants/caregivers';
import RateSelector from '../../common/RateSelector';
import IconButton from '../../common/IconButton';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import theme from '../../../theme';
import { parseDate } from '@internationalized/date';
import { toast } from 'react-toastify';
import TextButton from '../../common/TextButton';
import LoopRoundedIcon from '@mui/icons-material/LoopRounded';
import { KNOWEDGE_SELECTOR_DATA } from '../../../../constants/common';
import CustomModal from '../../common/CustomModal';
import EditRoundedIcon from '@mui/icons-material/EditRounded';
import { DEFAULT_TABLE_PAGINATION } from '../../../../constants/pagination';
import { getUserFamily } from '../../../../service/families';
import SuggestedCaregiversTable from '../../tables/SuggestedCareGiversTable';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';

interface IInterviewCareGiverSection {

}

export default function InterviewCareGiverSection({

}: IInterviewCareGiverSection) {

  const menuRef = React.useRef<HTMLDivElement>(null);
  const nameInputRef = React.useRef<HTMLInputElement>(null);
  const surnameInputRef = React.useRef<HTMLInputElement>(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { caregiver, family, distanceFromFamily } = useSelector((state: StoreState) => state.interview);
  const { userProfile } = useSelector((state: StoreState) => state.profile);
  const { paginatedData: caregiversPaginatedData } = useSelector((state: StoreState) => state.caregivers); 

  const [creatingCaregiver, setCreatingCaregiver] = React.useState<boolean>(false);
  const [loading, setLoading] = React.useState<boolean>(false);
  // filtri
  const [nameFilter, setNameFilter] = React.useState<string>('');
  const [surnameFilter, setSurnameFilter] = React.useState<string>('');
  const [searchResults, setSearchResults] = React.useState<CareGiver[]>([]);
  const [focused, setFocused] = React.useState<boolean>(false);

  /* ANAGRAFICA */
  const [name, setName] = React.useState<string>('');
  const [surname, setSurname] = React.useState<string>('');
  const [address, setAddress] = React.useState<string>('');
  const [birthDate, setBirthDate] = React.useState<DateValue | undefined>(undefined);
  const [telephone, setTelephone] = React.useState<string>('');
  const [nationality, setNationality] = React.useState<Selection>(new Set([]));
  const [references, setReferences] = React.useState<boolean>(false);
  const [coverageAvailability, setCoverageAvailability] = React.useState<Selection>(new Set([]));
  /* ESPERIENZE E CONOSCENZE */
  const [yearsOfExperience, setYearsOfExperience] = React.useState<string>('');
  const [languageKnowledge, setLanguageKnowledge] = React.useState<Selection>(new Set([]));
  const [cookingKnowledge, setCookingKnowledge] = React.useState<Selection>(new Set([]));
  /* CARATTERISTICHE / ASSISTENZA */
  const [traits, setTraits] = React.useState<TraitData[]>([]);
  /* CARATTERE BADANTE */
  const [personalities, setPersonalities] = React.useState<CareGiverPeronality[]>([]);
  /* INFO UTILI */
  const [nightTime, setNightTime] = React.useState<Selection>(new Set([]));
  const [weekendAvailability, setWeekendAvailability] = React.useState<Selection>(new Set([]));
  const [otherPeoplePresence, setOtherPeoplePresence] = React.useState<Selection>(new Set([])); 
  const [smokes, setSmokes] = React.useState<Selection>(new Set([]));
  /* ALTRO */
  const [referencesNumbers, setReferencesNumbers] = React.useState<string>('');
  const [notes, setNotes] = React.useState<string>('');
  // Traits NOTES
  const [traitNoteValue, setTraitNodeValue] = React.useState<string>('');
  const [selectedTrait, setSelectedTrait] = React.useState<Trait | null>(null);
  // Badanti consigliate
  const [tablePage, setTablePage] = React.useState<CaregiverWithAssignedFamilyData[]>([]);
  const [paginationConfig, setPaginationConfig] = React.useState<TablePaginationConfig>(DEFAULT_TABLE_PAGINATION);
  const [totalNumberOfPages, setTotalNumberOfPages] = React.useState<number>(1);

  React.useEffect(() => {
    initSearchValues();
    if (userProfile) {
      getSuggestedCaregivers(userProfile.uid).then(r => {
        console.log('💚', r)
      }).catch(console.log)
    }
    window.addEventListener('click', handleClick);
    return () => {
      window.removeEventListener('click', handleClick);
    }
  }, []);

  React.useEffect(() => {
    if (!family) {
      onCaregiverDiscard();
    } else {
      initTable();
    }
  }, [family]);

  React.useEffect(() => {
    if (caregiver) {
      loadCaregiverData(caregiver);
    }
  }, [caregiver]);

  const handleClick = (
    event: MouseEvent
  ) => {
    const menu = menuRef.current;
    const nameInput = nameInputRef.current;
    const surnameInput = surnameInputRef.current;
    if (!nameInput || !menu || !surnameInput) return;
    if (nameInput.contains(event.target as Node)) return;
    if (surnameInput.contains(event.target as Node)) return;
    if (menu.contains(event.target as Node)) return;
    setFocused(false);
  }

  const initTable = async () => {
    if (!userProfile) return;
    const page = await initSuggestedCaregiversTable(userProfile.uid);
    const newTablePage = await integrateCaregiverPageWithAssignedFamilyData(page.data, userProfile.uid);
    const nop = await getSuggestedCareGiverMaxNumberOfPagses(userProfile.uid, DEFAULT_TABLE_PAGINATION.size);
    setPaginationConfig({page: 1, maxPage: nop, size: DEFAULT_TABLE_PAGINATION.size, firstDoc: page.cursors.first, secondDoc: page.cursors.second, lastDoc: page.cursors.last});
    setTotalNumberOfPages(nop);
    setTablePage(newTablePage);
  }

  const fetchNetxTablePage = async () => {
    if (!userProfile) return;
    const { page, size, lastDoc, maxPage } = paginationConfig;
    if (!lastDoc) throw 'Invalid last doc';
    const nextTablePaginationConfig: TablePaginationConfig = { page: page + 1, size, lastDoc, maxPage };
    const nextPage = await loadSuggestedCaregiverNextTablePage(userProfile.uid, nextTablePaginationConfig);
    const newTablePage = await integrateCaregiverPageWithAssignedFamilyData(nextPage.data, userProfile.uid);
    setPaginationConfig({page: nextTablePaginationConfig.page, size, firstDoc: nextPage.cursors.first, secondDoc: nextPage.cursors.second, lastDoc: nextPage.cursors.last, maxPage});
    setTablePage(newTablePage);
  }

  const fetchPrevTablePage = async () => {
    if (!userProfile) return;
    const { page, size, firstDoc, maxPage } = paginationConfig;
    if (!firstDoc) throw 'Invalid Last doc';
    const prevPageConfig: TablePaginationConfig = { page: page - 1, size, firstDoc, maxPage };
    const prevPage = await loadSuggestedCaregiverPrevTablePage(userProfile.uid, prevPageConfig);
    const newTablePage = await integrateCaregiverPageWithAssignedFamilyData(prevPage.data, userProfile.uid);
    setPaginationConfig({page: prevPageConfig.page, size, firstDoc: prevPage.cursors.first, lastDoc: prevPage.cursors.last, maxPage});
    setTablePage(newTablePage);
  }

  const integrateCaregiverPageWithAssignedFamilyData = async (
    page: CareGiver[],
    uid: string,
  ): Promise<CaregiverWithAssignedFamilyData[]> => {
    const newFamilyPage: CaregiverWithAssignedFamilyData[] = [];
    for (const family of page) {
      const assignedTo = family.assignedTo;
      let caregiverAssignedFamilyData: CaregiverAssignedFamilyData | null = null;
      if (assignedTo) {
        const caregiverData = await getUserFamily(uid, assignedTo);
        caregiverAssignedFamilyData = { name: caregiverData.personalData.name, surname: caregiverData.personalData.surname };
      }
      newFamilyPage.push({...family, assingedFamilyData: caregiverAssignedFamilyData });
    }
    return newFamilyPage;
  }

  const initSearchValues = async () => {
    if (!userProfile) return;
    const initialResults = await initCaregiverSearchResults(userProfile.uid);
    setSearchResults(initialResults);
  }

  const reset = () => {
    setName('');
    setSurname('');
    setAddress('');
    setBirthDate(undefined);
    setTelephone('');
    setNationality(new Set([]));
    setReferences(false);
    dispatch(updateDistanceFromFamily(undefined));
    setCoverageAvailability(new Set());
    setYearsOfExperience('');
    setLanguageKnowledge(new Set([]));
    setCookingKnowledge(new Set([]));
    if (family) {
      const c_traits: TraitData[] = [];
      for (let t of family.traits) {
        c_traits.push({trait: t.trait, on: false});
      } 
      setTraits(c_traits);
    }
    setPersonalities([]);
    setNightTime(new Set([]));
    setWeekendAvailability(new Set([]));
    setOtherPeoplePresence(new Set([]));
    setSmokes(new Set([]));
    setReferencesNumbers('');
    setNotes('');
  }

  const submit = async() => {
    try {
      if (!userProfile) return;
      const careGiverFormData = getCareGiverFormData();
      if (caregiver) { // modifica
        const updatedCaregiverData = getUpdatedCaregiverData(careGiverFormData, caregiver);
        await updateUserCaregiver(userProfile.uid, updatedCaregiverData);
        dispatch(loadInterviewCareGiver(updatedCaregiverData));
        toast.success('Badante modificata con successo');
        console.log('FINITA MODIFICA')
      } else { // creazione
        const newCaregiver = await createUserCareGiver(userProfile.uid, careGiverFormData);
        dispatch(loadInterviewCareGiver(newCaregiver));
        toast.success('Badante creata con successo');
        console.log('FINITA CREAZIONE');
      }
      initTable();
      setCreatingCaregiver(false);
    } catch (error) {
      console.log(error);
      toast.error('Si è verificato un errore durante il salvataggio della badante');
    }
  }

  const getUpdatedCaregiverData = (
    formData: CareGiverFormData,
    c: CareGiver
  ): CareGiver => {
    const { name, surname } = formData.personalData;
    const nameSurnameKeyword = getStringKeywords(name, surname);
    const ageMetadata = ts2Age(formData.personalData.tsDateOfBirth);
    const positivePersonalities = getPositiviePersonalitiesMetadata(formData.personalities);
    const numberOfTraitsMetadata = getNumberOfTraitsMetadata(formData.traits);
    return {
      ...formData,
      id: c.id,
      tsCreated: c.tsCreated,
      tsUpdated: Date.now(),
      assignedTo: c.assignedTo,
      metadata: {
        keywords: nameSurnameKeyword,
        normalizedSurname: surname.toLocaleLowerCase(),
        numberOfTraits: numberOfTraitsMetadata,
        positivePersonalities,
        age: ageMetadata,
      }
    }
  } 

  const getCareGiverFormData = (): CareGiverFormData => {
    const calendarDate: CalendarDate = {
      day: birthDate?.day as number,
      month: birthDate?.month as number,
      year: birthDate?.year as number,
    };
    return {
      traits: traits,
      coockingKnowledge: Array.from(cookingKnowledge).length === 0 ? 0 : Number(Array.from(cookingKnowledge)[0]),
      languageKnowledge: Array.from(languageKnowledge).length === 0 ? 0 : Number(Array.from(languageKnowledge)[0]),
      personalities: personalities,
      yearsOfExperience: isNaN(parseInt(yearsOfExperience)) ? 0 : parseInt(yearsOfExperience),
      //usefulInfo: usefulInfo,
      nightTime: Array.from(nightTime).length === 0 ? '0' : Array.from(nightTime)[0] as CareGiverNightTime,
      otherPeoplePresence: Array.from(otherPeoplePresence).length === 0 ? '0' : Array.from(otherPeoplePresence)[0] as CareGiverOtherPeoplePresence,
      smokes: Array.from(smokes).length === 0 ? '0' : Array.from(smokes)[0] as CareGiverSmokes,
      weekendAvailability: Array.from(weekendAvailability).length === 0 ? '0' : Array.from(weekendAvailability)[0] as CareGiverWeekendAvailability,
      referencesNumbers,
      notes,
      personalData: {
        address: address,
        name: name,
        nationality: Array.from(nationality).length === 0 ? 'Italiana' : Array.from(nationality)[0] as CaregiverNationality,
        tsDateOfBirth: calendarDate2Timestamp(calendarDate),
        distanceFromFamily: distanceFromFamily || '0',
        references: references,
        surname: surname,
        telephone: telephone,
        coverageAvailability: Array.from(coverageAvailability).length > 0 ? Array.from(coverageAvailability)[0] as CareGiverCovergaeAvailability : undefined,
      }
    }
  }

  const onNewCaregiver = () => {
    onCaregiverDiscard();
    setCreatingCaregiver(true);
  }

  const loadCaregiverData = async (cg: CareGiver) => {
    if (!family || !userProfile) return;

    const c = cg;/* await getSingleUserCareGiver(userProfile.uid, cg.id); */

    const c_traits: TraitData[] = [];
    for (let t of family.traits) {
      const idx = c.traits.findIndex(el => el.trait === t.trait);
      c_traits.push({trait: t.trait, on: idx < 0 ? false : c.traits[idx].on, note: idx < 0 ? '' : c.traits[idx].note ?? ''});
    } 

    setName(c.personalData.name);
    setSurname(c.personalData.surname);
    setAddress(c.personalData.address);

    const date = new Date(c.personalData.tsDateOfBirth);
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    
    const stringInitialBirthDate = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
    const initialBirthDate = parseDate(stringInitialBirthDate);
    setBirthDate(initialBirthDate);

    setTelephone(c.personalData.telephone);
    setNationality(new Set([c.personalData.nationality]));
    setReferences(c.personalData.references);
    setCoverageAvailability(c.personalData.coverageAvailability ? new Set([c.personalData.coverageAvailability]) : new Set([]));
    //setDistanceFromFamily(c.personalData.distanceFromFamily);
    setYearsOfExperience(String(c.yearsOfExperience));
    setLanguageKnowledge(new Set([String(c.languageKnowledge)]));
    setCookingKnowledge(new Set([String(c.coockingKnowledge)]));
    setTraits(c_traits);
    setPersonalities(c.personalities);
    setNightTime(new Set([c.nightTime]));
    setWeekendAvailability(new Set([c.weekendAvailability]));
    setOtherPeoplePresence(new Set(c.otherPeoplePresence));
    setSmokes(new Set([c.smokes]));
    setReferencesNumbers(c.referencesNumbers);
    setNotes(c.notes);
  }

  const onCaregiverDiscard = () => {
    onNameChange('');
    onSurnameChange('');
    setFocused(false);
    dispatch(loadInterviewCareGiver(null));
    setCreatingCaregiver(false);
    setLoading(false);
    reset();
  }

  const onCaregiverSelect = (
    caregiverId: string
  ) => {
    const caregiverIdx = searchResults.findIndex(el => el.id === caregiverId);
    const newSelectedCaregiver = searchResults[caregiverIdx];
    dispatch(loadInterviewCareGiver(newSelectedCaregiver));
    loadCaregiverData(newSelectedCaregiver);
    onSurnameChange('');
    onNameChange('');
  }

  const onSuggestedCaregiverSelect = async (id: string) => {
    if (!userProfile) return;
    const caregiver = await getSingleUserCareGiver(userProfile.uid, id);
    dispatch(loadInterviewCareGiver(caregiver));
    loadCaregiverData(caregiver);
    onSurnameChange('');
    onNameChange('');
  }

  /* FORM FUNCTIONS */
  const onAddPersonality = (
    pe: any
  ) => {
    const pers = Array.from(new Set(pe))[0] as CareGiverPeronality;
    const idx = personalities.findIndex(el => el === pers);
    if (idx < 0) {
      setPersonalities(prev => {
        const newPersonalities = brkRef(prev);
        newPersonalities.push(pers);
        return newPersonalities;
      })
    }
  }

  const onRemovePersonality = (pers: CareGiverPeronality) => {
    setPersonalities(prev => {
      const newPersonalities = brkRef(prev);
      const idx = prev.findIndex(el => el === pers);
      if (idx >= 0) {
        newPersonalities.splice(idx, 1);
      }
      return newPersonalities
    });
  }

  const onToggleTrait = (trait: Trait) => {
    setTraits(prev => {
      const newTraits = brkRef(prev);
      const idx = prev.findIndex(el => el.trait === trait);
      if (idx >= 0) {
        newTraits[idx].on = !prev[idx].on;
      }
      return newTraits;
    })
  }

  const onTraitNoteEdit = () => {
    if (!selectedTrait) return;
    setTraits(prev => {
      const newTraits = brkRef(prev);
      const idx = newTraits.findIndex(el => el.trait === selectedTrait);
      if (idx >= 0) {
        newTraits[idx].note = traitNoteValue;
      }
      return newTraits;
    })
  }

  /* FILTRI */
  const onNameChange = async (
    value: string
  ) => {
    setNameFilter(value);
    if (!userProfile) return;
    if (value.length === 0 && surnameFilter.length === 0) {
      initSearchValues();
    } else {
      const searchRes = await searchCaregiverByNameSurname(userProfile.uid, value, surnameFilter);
      setSearchResults(searchRes);
    }
  }

  const onSurnameChange = async (
    value: string
  ) => {
    setSurnameFilter(value);
    if (!userProfile) return;
    if (value.length === 0 && nameFilter.length === 0) {
      initSearchValues();
    } else {
      const searchRes = await searchCaregiverByNameSurname(userProfile.uid, nameFilter, value);
      setSearchResults(searchRes);
    }
  }
  
  return (
    <div className='w-full h-full flex flex-col'>
      <div className='flex justify-center items-center' style={{position: 'relative'}}>
        <Typography style={{fontWeight: 700}}>Badante</Typography>
        {
          caregiver && (
            <TextButton
              style={{
                position: 'absolute',
                right: 0,
              }}
              icon={<LoopRoundedIcon style={{color: theme.color.primary}}/>}
              title='Cambia badante'
              onPress={onCaregiverDiscard}
              />
          )
        }
      </div>
      {
        !caregiver && !creatingCaregiver && (
          <div className='flex flex-col grow-1 flex-1 mt-4'>
            <div style={{display: 'flex', gap: theme.sizing.x1}}>
              <div style={{display: 'flex', flex: 1, gap: theme.sizing.x1, position: 'relative'}}>
                <Input 
                  value={nameFilter}
                  ref={nameInputRef}
                  placeholder='Nome'
                  isDisabled={!family}
                  onValueChange={onNameChange}
                  onFocus={() => setFocused(true)}
                  style={{flex: 5}}/>
                <Input 
                  value={surnameFilter}
                  ref={surnameInputRef}
                  isDisabled={!family}
                  placeholder='Cognome'
                  onValueChange={onSurnameChange}
                  onFocus={() => setFocused(true)}
                  style={{flex: 5}}/>
                { focused && (
                  <div 
                  ref={menuRef}  
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    position: 'absolute',
                    top: 40 + 8, // input + spacing (gap)
                    left: 0,
                    right: 0,
                    backgroundColor: '#F4F4F5',
                    overflow: 'scroll',
                    borderRadius: theme.sizing.x2,
                    padding: theme.sizing.x2,
                    gap: theme.sizing.x1,
                    maxHeight: 250,
                    zIndex: 10,
                  }}>
                    {
                      searchResults.map((caregiver) => (
                        <div
                          key={caregiver.id}
                          style={{
                            cursor: 'pointer',
                            display: 'flex',
                            flex: 1,
                            justifyContent: 'space-between',
                            backgroundColor: 'white',
                            padding: theme.sizing.x1,
                            borderRadius: theme.sizing.x1,
                            alignItems: 'center',
                          }}
                          onClick={() => onCaregiverSelect(caregiver.id)}>
                            <div>
                            <Typography variant='label'>{caregiver.personalData.name} {caregiver.personalData.surname}</Typography>
                            <Typography variant='label' colorVariant='textLabel'>{caregiver.personalData.address}</Typography>
                          </div>
                          <Typography variant='label' colorVariant='textLabel'>
                            {ts2Age(caregiver.personalData.tsDateOfBirth).toString()} Anni
                          </Typography>
                        </div>
                      ))
                    }
                  </div>
                )}
              </div>
              <Button
                onClick={onNewCaregiver}
                disabled={!family}
                variant="secondary" 
                title='Nuova'/>
            </div>
            {
              !caregiver && !creatingCaregiver && family && tablePage.length > 0 && (
                <div className='w-full h-full flex flex-1' style={{flexDirection: 'column', marginTop: theme.sizing.x4, gap: theme.sizing.x2}}>
                  <div style={{flexDirection: 'column', display: 'flex'}}>
                    <Typography
                      style={{fontWeight: 700}} 
                      colorVariant='textTertiary'>
                        BADANTI CONSIGLIATE
                    </Typography>
                    <Typography
                      colorVariant='textLabel'
                      variant='label'>
                      Potrebbero andare bene per la famiglia selezionata
                    </Typography>
                  </div>
                  <SuggestedCaregiversTable 
                    data={tablePage}
                    onSelect={(c) => onSuggestedCaregiverSelect(c.id)}/>
                  <div className='flex justify-end gap-4 items-center'>
                  <NUIButton isIconOnly size='sm' onClick={fetchPrevTablePage} isDisabled={paginationConfig.page === 1}>
                    <ArrowBackIosNewIcon fontSize='small'/>
                  </NUIButton>
                  <p>{paginationConfig.page}</p>
                  <NUIButton isIconOnly size='sm' onClick={fetchNetxTablePage} isDisabled={paginationConfig.page >= totalNumberOfPages}>
                    <ArrowForwardIosIcon fontSize='small'/>
                  </NUIButton>
                </div>
                </div>
              )
            }
          </div>
        )
      }
      {/* FORM => TODO: Da riutilizzare in pagina creazione badante */}
      {
        (caregiver || creatingCaregiver) && (
          <div className='w-full h-full mt-8'>
            {/* ======= ANAGRAFICA ======= */}
            <div>
              <Typography
                style={{fontWeight: 700}} 
                colorVariant='textTertiary'>
                  ANAGRAFICA
              </Typography>
              <div className='flex items-center gap-3 mt-3'>
                <Input value={name} onValueChange={setName} label="Nome" className='flex-[4]'/>
                <Input value={surname} onValueChange={setSurname} label="Cognome" className='flex-[4]'/>
                <DateInput label={"Data di nascita"} className='flex-[2]' value={birthDate} onChange={setBirthDate} isInvalid={false}/>
              </div>
              <div className='flex gap-4 mt-3'>
                <Input value={address} onValueChange={setAddress} label="Indirizzo" className='flex-[5]'/>
                <Input value={telephone} onValueChange={setTelephone} label="Numero di telefono" className='flex-[5]'/>
              </div>
              <div className='flex gap-4 mt-3'>
                <Input value={distanceFromFamily} onValueChange={(val) => dispatch(updateDistanceFromFamily(val))} label="Distanza" className='flex-[5]'/>
                <Select
                  className='flex-[5]'
                  label='Nazionalità'
                  selectedKeys={nationality}
                  onSelectionChange={setNationality}>
                    {
                      CAREGIVER_NATIONALITIES_SELECTOR_DATA.map((n) => (
                        <SelectItem key={n.key}>{n.value}</SelectItem>
                      ))
                    }
                  </Select>
                <Switch
                  isSelected={references}
                  onValueChange={() => setReferences(prev => !prev)}>
                    Referenze
                </Switch>
              </div>
              <Select 
                className='mt-3'
                label='Che tipo di lavoro cerchi?'
                selectedKeys={coverageAvailability}
                onSelectionChange={setCoverageAvailability}>
                  {
                    CAREGIVER_COVERAGE_AVAILABILITY.map((e) => (
                      <SelectItem key={e.key}>{e.value}</SelectItem>
                    ))
                  }
                </Select>
            </div>

            {/* ESPERIENZA E CONOSCENZE */}
            <div className='mt-8'>
              <Typography
                style={{fontWeight: 700}} 
                colorVariant='textTertiary'>
                  ESPERIENZA E CONOSCENZE
              </Typography>
              <Input value={yearsOfExperience} onValueChange={setYearsOfExperience} label="Anni di esperienza" className='w-60 mt-3'/>
              <div className='flex flex-wrap gap-3 mt-3'>
              <Select 
                label='Conoscenza italiano'
                selectedKeys={languageKnowledge}
                onSelectionChange={setLanguageKnowledge}>
                  {
                    KNOWEDGE_SELECTOR_DATA.map((e) => (
                      <SelectItem key={e.key}>{e.value}</SelectItem>
                    ))
                  }
                </Select>
                <Select 
                  label='Conoscenza cucina'
                  selectedKeys={cookingKnowledge}
                  onSelectionChange={setCookingKnowledge}>
                    {
                      KNOWEDGE_SELECTOR_DATA.map((e) => (
                        <SelectItem key={e.key}>{e.value}</SelectItem>
                      ))
                    }
                  </Select>
            </div>
            </div>


            {/* CARATTERISTICA ASSISTENZA */}
            {
              traits.length > 0 && (
                <div className='mt-8'>
                  <Typography
                    style={{fontWeight: 700}} 
                    colorVariant='textTertiary'>
                      CONOSCENZE DELLA BADANTE
                  </Typography>
                  <Table removeWrapper className='mt-3'>
                    <TableHeader>
                      <TableColumn>NOME CARATTERISTICA</TableColumn>
                      <TableColumn>NOTE</TableColumn>
                      <TableColumn> </TableColumn>
                    </TableHeader>
                    <TableBody>
                      {traits.map((ft, i) => (
                        <TableRow key={i}>
                          <TableCell>
                            <Typography colorVariant='primary' variant='button' style={{fontWeight: 600}}>{ft.trait}</Typography>
                          </TableCell>
                          <TableCell>
                            <div style={{display: 'flex', alignItems: 'center'}}>
                              {
                                ft.note ? (
                                  <Typography variant='button' style={{
                                    flex: 1,
                                    whiteSpace: 'nowrap',
                                    maxWidth: '250px',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                  }}>{ft.note}</Typography>
                                ) : (
                                  <Typography variant='button' colorVariant='textLabel' style={{fontStyle: 'italic'}}>Nessuna nota</Typography>
                                )
                              }
                              <IconButton 
                                backgroundColorVariant='none'
                                onClick={() => {
                                  setTraitNodeValue(ft.note ?? '');
                                  setSelectedTrait(ft.trait);
                                }}
                                icon={<EditRoundedIcon style={{color: theme.color.primary}}/>}/>
                            </div>
                          </TableCell>
                          <TableCell>
                            <Switch
                              isSelected={ft.on}
                              onValueChange={() => onToggleTrait(ft.trait)} />
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table> 
                </div>
              )
            }


            {/* CARATTERE BADANTE */}
            <div className='mt-8'>
              <Typography
                style={{fontWeight: 700}} 
                colorVariant='textTertiary'>
                  CARATTERE
              </Typography>
              {
                personalities.length > 0 && (
                  <Table removeWrapper className='mt-3'>
                    <TableHeader>
                      <TableColumn>CARATTERE</TableColumn>
                    </TableHeader>
                    <TableBody>
                      {personalities.map((ft, i) => (
                        <TableRow key={i}>
                          <TableCell className='flex items-center'>
                            <IconButton 
                              backgroundColorVariant='none'
                              onClick={() => onRemovePersonality(ft)}
                              icon={<DeleteRoundedIcon style={{color: theme.color.primary}}/>}/>
                            <Typography colorVariant='primary' variant='button' style={{fontWeight: 600}}>{ft}</Typography>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>    
                )
              }
              <div className='flex gap-4 items-center'>
                <Select
                  className='mt-3'
                  label="Seleziona un carattere" 
                  selectedKeys={new Set([])}
                  onSelectionChange={onAddPersonality}>
                  {CARE_GIVER_PERSONALITIES_SELECTOR_DATA.map((personality) => (
                    <SelectItem key={personality.key}>
                      {personality.value}
                    </SelectItem>
                  ))}
                </Select>
              </div>
            </div>

            {/* INFO UTILI */}
            <div className='mt-8'>
        <p>INFO UTILI PER BADANTE</p>
        <div className='flex flex-col gap-4 mt-4'>
          {/*
            usefulInfo.map((ui, i) => (
              <div className='flex flex-row gap-4' key={i}>
                <div className='flex flex-1'>
                  <p>{ui.name}</p>
                </div>
                <Switch 
                  isSelected={ui.value}
                  onValueChange={() => {
                    setUsefulInfo(prev => {
                      const newUsefulInfo = brkRef(prev);
                      newUsefulInfo[i].value = !newUsefulInfo[i].value;
                      return newUsefulInfo;
                    })
                  }} />
              </div>
            ))
          */}
          <Select
            className='mt-1'
            label="Disponibilità ad alzarsi di notte" 
            selectionMode='single'
            selectedKeys={nightTime}
            onSelectionChange={setNightTime}>
            {CAREGIVERS_NIGHT_TIME.map((nt) => (
              <SelectItem key={nt.key}>
                {nt.value}
              </SelectItem>
            ))}
          </Select>
          <Select
            className='mt-1'
            label="Disponibilità al lavoro nel weekend" 
            selectionMode='single'
            selectedKeys={weekendAvailability}
            onSelectionChange={setWeekendAvailability}>
            {CAREGIVER_WEEKEND_AVAILABILIY.map((wa) => (
              <SelectItem key={wa.key}>
                {wa.value}
              </SelectItem>
            ))}
          </Select>
          <Select
            className='mt-1'
            label="Fuma" 
            selectionMode='single'
            selectedKeys={smokes}
            onSelectionChange={setSmokes}>
            {CAREGIVER_SMOKES.map((s) => (
              <SelectItem key={s.key}>
                {s.value}
              </SelectItem>
            ))}
          </Select>
          <Select
            className='mt-1'
            label="Disponibilità a lavorare con altre persone" 
            selectionMode='single'
            selectedKeys={otherPeoplePresence}
            onSelectionChange={setOtherPeoplePresence}>
            {CAREGIVER_OTHER_PEOPLE_PRESENCE.map((pp) => (
              <SelectItem key={pp.key}>
                {pp.value}
              </SelectItem>
            ))}
          </Select>
        </div>
      </div>

            {/* ALTRO */}
            <div className='mt-8'>
              <Typography
                style={{fontWeight: 700}} 
                colorVariant='textTertiary'>
                  ALTRO
              </Typography>
              <div className='mt-2 flex flex-col gap-4'>
                <Textarea 
                  label={'Numeri per referenze'} 
                  placeholder='Numeri di telefono e nominativi per le referenze'
                  value={referencesNumbers}
                  onValueChange={setReferencesNumbers} />
                <Textarea label='Note' placeholder='Inserisci note'
                value={notes}
                onValueChange={setNotes} />
              </div>
            </div>

          </div>
        )
      }

      {
        (caregiver || creatingCaregiver) && (
          <div className='flex flex-col gap-2 mt-16'>
            <Button 
              title='Salva badante'
              onClick={submit}/>
            <Button 
              title='Annulla'
              variant='secondary'
              onClick={onCaregiverDiscard} />
          </div>
        )
      }
      <CustomModal
        isOpen={!!selectedTrait}
        onOpenChange={() => setSelectedTrait(null)}
        content={
          <div style={{
            display: 'flex',
            flex: 1,
            paddingTop: theme.sizing.x5,
            flexDirection: 'column',
            gap: theme.sizing.x4,
          }}>
            <div style={{display: 'flex', gap: theme.sizing.x2, flexDirection: 'column'}}>
              <Typography 
                variant='headline3'
                style={{fontWeight: 700}} 
                colorVariant='textTertiary'>Modifica Nota</Typography>
              <Textarea label='Note' placeholder='Inserisci note'
                maxLength={100}
                value={traitNoteValue}
                onValueChange={setTraitNodeValue} />
            </div>
             <div style={{display: 'flex', gap: theme.sizing.x1, marginLeft: 'auto'}}>
              <Button 
                title='Chiudi'
                onClick={() => {
                  setTraitNodeValue('');
                  setSelectedTrait(null);
                }} />
                <Button  
                  title='Salva'
                  onClick={() => {
                    onTraitNoteEdit();
                    setTraitNodeValue('');
                    setSelectedTrait(null);
                  }}/>
             </div>
          </div>
        } />
    </div>
  )
}